import { render, staticRenderFns } from "./ColSort.vue?vue&type=template&id=5cf1d082&scoped=true&"
import script from "./ColSort.vue?vue&type=script&lang=js&"
export * from "./ColSort.vue?vue&type=script&lang=js&"
import style0 from "./ColSort.vue?vue&type=style&index=0&id=5cf1d082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf1d082",
  null
  
)

export default component.exports